import { useState } from 'react'
import { useNavigate } from "react-router-dom";
import { useMutation } from "@apollo/client";
import SideMenu from '../layouts/SideMenu';
import Modal from '../layouts/Modal';
import '../layouts/stylesheets/loader-style.css';
import { UPDATE_USER_PASSWORD_QUERY } from '../services/GraphQLQueries';
import { clearAuthStorage } from '../services/auth';


export default function ChangePassword() {
    const [updatePasswordMutation, { loading }] = useMutation(UPDATE_USER_PASSWORD_QUERY);
    const [resetPasswordForm, setResetPasswordForm] = useState({
        password: '',
    });
    const [isSuccessModalOpen, setIsSuccessModalOpen] = useState(false);
    const navigate = useNavigate();

    const handleChange = (event) => {
        setResetPasswordForm({ ...resetPasswordForm, [event.target.id]: event.target.value });
    }
    const [formErrors, setFormErrors] = useState({ errors: {} });

    const saveNewPassword = async (e) => {
        e.preventDefault()
        let errors = {};
        let proceed = true;
        if (resetPasswordForm.password.length < 3) {
            errors.password = 'Please enter your password.';
            proceed = false;
        }
        if (!proceed) {
            setFormErrors({ ...formErrors, errors });
            return;
        }

        updatePasswordMutation({
            variables: { password: resetPasswordForm.password },
            onCompleted: data => {
                const result = data?.updateUserPassword
                if (result?.error) {
                    setFormErrors({ errors: { ...formErrors.errors, password: result.error } })
                    return
                }
                clearAuthStorage({ notify: false })
                setIsSuccessModalOpen(true)
            },
            onError: error => {
                setFormErrors({ errors: { ...formErrors.errors, password: error.message } })
            }
        });
    }

    const returnToLogin = () => {
        clearAuthStorage()
        setIsSuccessModalOpen(false)
        navigate("/signin", { replace: true });
    }
    
    return (
        <div className="flex justify-center items-center" aria-live="polite">
            <SideMenu></SideMenu>
            <div className="w-full flex justify-center">
                {loading ? (
                    <>
                        <div className="loader-wrapper">
                            <div className='flex justify-center items-center'>
                                <div className='grid gap-10'>
                                    <div className="loader"></div>
                                    <div className='text-center'>Resetting...</div>
                                </div>
                            </div>
                        </div>
                    </>
                ) : (
                    <div className='grid gap-6 md:w-96 w-72 mb-36'>
                        <div className='flex justify-center'>
                            <h3 className='w-full text-3xl font-semibold text-gray-900 text-center'>Reset Your Password</h3>
                        </div>
                        <div>
                            <p className='text-gray-700 text-sm font-medium mb-1'>Password*</p>
                            <input type="password" id="password"
                                className=" text-black border border-gray-300 placeholder-gray-500 block w-full p-2"
                                placeholder="Enter your new password" required
                                value={resetPasswordForm.password}
                                onChange={handleChange} />
                            {formErrors.errors.password ? <p style={{ color: '#f44', 'fontWeight': 'bold', 'textAlign': 'center' }}>{formErrors.errors.password}</p> : ''}
                        </div>
                        <input type="button" id="continue" onClick={saveNewPassword}
                            className="bg-onTrack-light-purple font-semibold text-white text-center placeholder-white rounded-md block w-full p-2"
                            placeholder="Save" value='Save' />
                    </div>
                )}
            </div>
            {isSuccessModalOpen && (
                <Modal
                    setIsModalOpen={setIsSuccessModalOpen}
                    backGroundClass={'darkBG'}
                    dismissModal={returnToLogin}
                >
                    <div className="mx-auto max-w-md p-6 text-center">
                        <h2 className="mb-3 text-2xl font-semibold text-gray-900">
                            Password changed
                        </h2>
                        <p className="mb-6 text-base text-gray-700">
                            Your password has been changed. You will now be returned to the login page.
                        </p>
                        <button
                            type="button"
                            className="w-full rounded-md bg-black px-5 py-3 font-semibold text-white"
                            onClick={returnToLogin}
                        >
                            Return to login
                        </button>
                    </div>
                </Modal>
            )}
        </div>
    )
}
